// extracted by mini-css-extract-plugin
export var container = "productsPage-module--container--3Sg1x";
export var marginTop = "productsPage-module--marginTop--1iepX";